<script>
import { authComputed } from '@/store/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      AdmitInfoList: [],
    }
  },
  async created() {
    await this.getAdmInfo();
  },
  computed: {
    ...authComputed,
    unreadAdmitCount() {
      return this.AdmitInfoList.filter(c => c.ReadFlag == 0).length
    },
    userInitial() {
      const name = this.$store.state.Admin.Username || ''
      return name.charAt(0).toUpperCase() || '?'
    },
    greeting() {
      const h = new Date().getHours()
      if (h < 12) return 'สวัสดีตอนเช้า'
      if (h < 18) return 'สวัสดีตอนบ่าย'
      return 'สวัสดีตอนเย็น'
    },
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    logout() {
      this.$store.commit('clearAuth')
      this.$router.push({ name: 'login' })
    },


    //GetAdmitInfoByAdmin
    async getAdmInfo() {
      let self = this;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
      };
      await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/order/GetAdmitInfoByAgent', config)
        .then(function (res) {
          if (res.status == 200) {
            self.AdmitInfoList = res.data;
            //console.log(self.NotificationsAgentUpdate)
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
        });
    },
    async markAsReadWithRedirectAdmInfo(id, orderId) {
      console.log("xx", id, orderId)
      await this.updateAdmInfoStatus(id, 1);

      //this.$router.push({ name: 'job-edit', params: { slug: id } });
      const routeData = this.$router.resolve({ name: 'job-edit', params: { slug: orderId } });
      window.open(routeData.href, '_blank');
    },
    async markAsReadWithRedirectgetAdmInfoUpdate(id, refId) {
      await this.updateAdmInfoStatus(id, 1);
      const routeData = this.$router.resolve({ name: 'agent-edit', params: { slug: refId } });
      window.open(routeData.href, '_blank');
    },
    markAsReadAdmInfo(id) {
      this.updateAdmInfoStatus(id, 1);
    },
    markAsUnReadAdmInfo(id) {
      this.updateAdmInfoStatus(id, 0);
    },
    markAsHideAdmInfo(id) {
      this.updateAdmInfoStatus(id, 2);
    },
    async updateAdmInfoStatus(id, readFlag) {
      let self = this;
      let param = { Id: id, ReadFlag: readFlag };

      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
      };

      await this.axios.put(process.env.VUE_APP_OFFICEAPI_URL + '/api/order/UpdateAdmitInfoStatus', param, config)
        .then(function (res) {
          if (res.status == 200) {
            console.log(res.data)
            self.getAdmInfo();
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
        });
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <!-- LOGO -->
    <div class="logo-box">
      <router-link tag="a" :to="{ name: 'home' }" class="logo w-100">
        <span class="logo-lg logo-chip d-flex justify-content-center">
          <img src="@/assets/logo-white.png" alt="ศรีกรุง" height="34" class="px-4" />
        </span>
        <!-- <span class="logo-sm logo-chip logo-chip--sm">
          <img src="@/assets/logo-white.png" alt="ศรีกรุง" height="24" />
        </span> -->
      </router-link>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button class="button-menu-mobile" @click="toggleMenu" aria-label="สลับเมนู">
          <i class="fe-menu"></i>
        </button>
      </li>
    </ul>

    <ul class="list-unstyled topnav-menu topnav-menu-right float-right mb-0">
      <li>
        <button type="button" class="topbar-icon-btn" v-b-toggle.notiAdmBar
          title="ข้อมูลลูกค้าเข้ารับการรักษาที่โรงพยาบาล" aria-label="การแจ้งเตือนผู้ป่วยใน">
          <i class="fas fa-user-md"></i>
          <span v-if="unreadAdmitCount > 0" class="topbar-icon-btn__badge">{{ unreadAdmitCount }}</span>
        </button>
      </li>
      <li>
        <div class="user-info-block">
          <span class="user-info-block__greeting">{{ greeting }}</span>
          <span class="user-info-block__email">{{ $store.state.Admin.Email }}</span>
          <span v-if="$store.state.Admin.Role" class="user-info-block__role">ทีม {{ $store.state.Admin.Role }} SRIKRUNG LIFE</span>
        </div>
      </li>
      <!-- <li>
        <span class="user-chip__avatar" :title="$store.state.Admin.Username">{{ userInitial }}</span>
      </li> -->
      <li>
        <button type="button" class="topbar-icon-btn" @click="logout" title="ออกจากระบบ" aria-label="ออกจากระบบ">
          <i class="fe-log-out"></i>
        </button>
      </li>
    </ul>

    <b-sidebar v-if="AdmitInfoList.length > 0" id="notiAdmBar"
      :title="'ข้อความแจ้งเตือน ' + unreadAdmitCount + ' รายการ'" shadow backdrop
      width="800px">

      <div class="px-3 py-3">
        <div class="row">
          <div v-for="(row, idx) in AdmitInfoList" :key="idx" class="col-lg-6 col-sm-12">
            <b-card size="sm" class="noti-card" :class="{ 'noti-card--unread': row.ReadFlag == 0 }"
              header-class="noti-card__header">
              <template #header>
                <div class="noti-card__header-row">
                  <span class="noti-card__icon" :title="row.ReadFlag == 0 ? 'ข้อความใหม่' : 'อ่านแล้ว'">
                    <i :class="row.ReadFlag == 0 ? 'fas fa-envelope' : 'fas fa-envelope-open'"></i>
                  </span>
                  <span class="noti-card__type">{{ row.InsuranceTxt }}</span>
                  <button v-if="row.ReadFlag == 0" type="button" class="noti-card__action"
                    @click="markAsReadAdmInfo(row.Id)" title="ทำเครื่องหมายว่าอ่านแล้ว" aria-label="ทำเครื่องหมายว่าอ่านแล้ว">
                    <i class="fas fa-bell-slash"></i>
                  </button>
                  <button v-else type="button" class="noti-card__action"
                    @click="markAsUnReadAdmInfo(row.Id)" title="ทำเครื่องหมายว่ายังไม่อ่าน" aria-label="ทำเครื่องหมายว่ายังไม่อ่าน">
                    <i class="fas fa-bell"></i>
                  </button>
                </div>
              </template>
              <b-card-title>กรมธรรม์ {{ row.Policy }}</b-card-title>
              <div class="text-nowrap"><span class="font-weight-bold pr-2">ตัวแทน</span> {{ row.AgentId }}</div>
              <div class="text-nowrap"><span class="font-weight-bold pr-2">ผู้เอาประกัน</span> {{ row.FirstName }} {{
                row.LastName }}
              </div>
              <div class="text-nowrap"><span class="font-weight-bold pr-2">วันที่เข้ารับการรักษา</span>{{
                dateThTimeFormat(row.AdmitDate, 'DD MMMM YYYY') }}
              </div>
              <div class="text-nowrap"><span class="font-weight-bold pr-2">โรงพยาบาล</span> {{ row.Hospital }}</div>
              <div class="text-nowrap"><span class="font-weight-bold pr-2">Remark</span> {{ row.Remark }}</div>
            </b-card>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}

.ps>.ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
  width: 6px !important;
}

.button-menu-mobile {
  outline: none !important;
}
</style>
